// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@awc/XDL/types";
import { color, styledScrollbar } from "@awc/XDL/Utilities";
import { TabProps } from "@insite/mobius/Tab";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
        typographyProps: {
            variant: "h6",
            forwardAs: "span",
            color: "common.ui1",
            css: css`
                margin-bottom: 0;
            `,
        },
        css: css`
            position: relative;
            background-color: ${color("common.ui14")};
            padding: 8px 16px;
            cursor: pointer;
            border: unset;
            &:hover {
                border: unset;
            }

            &:focus {
                outline: none;
            }

            ${({ selected }: TabProps) =>
                selected &&
                css`
                    z-index: 1;
                    background-color: ${color("primary.main")};

                    &,
                    &:hover {
                        border: unset;
                    }
                `}
        `,
    },
    groupDefaultProps: {
        mergeCss: true,
        cssOverrides: {
            tabGroup: css`
                padding: 0 2px 0 0;
                position: relative;

                & > li:not(:last-child) {
                    margin-right: 16px;
                }

                border-bottom: 8px solid ${color("common.ui14")};

                ${styledScrollbar()}
            `,
            tabContent: css`
                position: relative;
                margin-top: 0;
                padding: 0;
                border-top: 0;
                border-bottom: 0;
            `,
            wrapper: css`
                width: 100%;
            `,
        },
    },
} as xBaseTheme["tab"];
